<template>
    <div class="user_orders_Settings">
        <!--
        <div class="intro">
            <div class="panel-tag">
                {{ __t('UKLON.IMAGES') }}
            </div>
        </div>
-->
        <b-tabs pills card vertical class="">
            <b-tab title-link-class="" :key="item.comp"  :active="item.is_active"  v-for="(item,idx) in pwa_res">
                <template slot="title">
                    <div class="fs-lg px-4 text-center ">
                        {{item.name }}
                    </div>
                </template>

                <b-card-text>
                    <component :location="location" v-bind:is="item.comp" ></component>
                </b-card-text>
            </b-tab>
        </b-tabs>

    </div>
</template>

<script>

import uklon_logo from "./image_tabs/uklon_logo.vue";
import uklon_photo from "./image_tabs/uklon_photo.vue";

export default {
    name: "uklon_image_tab",
    props: {
        location: {
            type: Object
        }
    },
    components: {
        uklon_logo,
        uklon_photo,
    },

    methods: {

    },

    computed : {
        pwa_res () {
            return [
                {
                    'name' : this.__t('uklon_logo'),
                    'comp' : 'uklon_logo',
                    'is_active' : true,
                },
                {
                    'name' : this.__t('uklon_photo'),
                    'comp' : 'uklon_photo',
                    'is_active' : false,
                },
            ]
        }

    }

}
</script>

<style scoped>

</style>
